import React from 'react'
import { CommandItem } from 'cmdk'

import { CheckIcon } from '../Icon'

export interface SmartSelectItemSingleProps extends React.ComponentProps<typeof CommandItem> {
  active: boolean
  label: string | JSX.Element
}

export const SmartSelectItemSingle = ({
  active = false,
  label,
  onSelect,
  value
}: SmartSelectItemSingleProps): JSX.Element => {
  return (
    <CommandItem key={value} value={value} data-active={active} data-variant={'single'} onSelect={onSelect}>
      {label}
      <CheckIcon color={'light-dark(var(--brand-blue-300), var(--brand-grey-100))'} />
    </CommandItem>
  )
}
